import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearCustomerBackUrl} from "../config/crystalclear-customer-back-url";
import {Broker} from "../../model/customer/broker";

@Injectable({
  providedIn: 'root'
})
export class CustomerBrokerService extends CommonCrudService<Broker> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearCustomerBackUrl.GET_CUSTOMER_BROKER_LIST,
      CrystalclearCustomerBackUrl.SAVE_CUSTOMER_BROKER,
      CrystalclearCustomerBackUrl.DELETE_CUSTOMER_BROKER);
  }

}
